import { Routes } from '@angular/router';
import { MobileViewComponent } from './pages/mobile-view/mobile-view.component';

export const MobileRoutes: Routes = [{ path: '', pathMatch: 'full', component: MobileViewComponent }];
